import LawyerDashboard from "./LawyerDashboard";

export default LawyerDashboard;
